<template lang="html">
	<core-page class="omapi-omu">
		<common-alerts id="omu-errors" :alerts="alerts" />
		<common-card v-if="!connected" class="omapi-omu__upgrade">
			<h2>Register now to unlock access to OptinMonster University!</h2>
			<p>
				<mark>
					Get instant access to our library of expert courses, guides, video training and ebooks with ANY
					OptinMonster subscription.
				</mark>
				<br />
			</p>
			<core-wizard-button color="green" size="xlarge">Start Learning Today For Free</core-wizard-button>
		</common-card>
		<common-card>
			<university-courses />
			<hr />
			<university-guides />
		</common-card>
		<modals-university-promo />
	</core-page>
</template>

<script lang="js">
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
	computed: {
		...mapGetters(['connected']),
		...mapState(['alerts']),
	},
	mounted() {
		this.fetchGuides();
		this.fetchCourses();
	},
	methods: {
		...mapActions('omu', ['fetchGuides', 'fetchCourses']),
	},
};
</script>

<style lang="scss">
@import '../assets/scss/variables';
@import '../assets/scss/pages/omu';
</style>
